module.exports = __webpack_public_path__ + "assets/header-logo-white-wrap.433bc6de.svg";